import { useState, useEffect } from 'react';
const includes = (array, value) => array.indexOf(value) !== -1;
var includes$1 = includes;
const TAG_NAME_INVALID = ['STYLE', 'SCRIPT'];
const getElementsBySelector = portalSelector => {
  var _document, _document2;
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return {
      bodyElements: [],
      portalElements: []
    };
  }
  const bodyElements = (_document = document) !== null && _document !== void 0 && (_document = _document.body) !== null && _document !== void 0 && _document.children ? [].slice.call(document.body.children) : [];
  const portalElements = (_document2 = document) !== null && _document2 !== void 0 && _document2.querySelectorAll(portalSelector) ? [].slice.call(document.querySelectorAll(portalSelector)) : [];
  const elementsWithoutAriaHidden = bodyElements.filter(element => element.getAttribute('aria-hidden') !== 'true' || !element.getAttribute('aria-hidden'));
  return {
    bodyElements: elementsWithoutAriaHidden,
    portalElements
  };
};
const addAriaHidden = _ref => {
  let {
    outsideElements = [],
    portalContainer,
    portalElements = []
  } = _ref;
  outsideElements.forEach(node => {
    if (!node) return;
    if (includes$1(TAG_NAME_INVALID, node.tagName)) return;
    if (portalElements.length && portalElements.some(n => n.isEqualNode(node))) return;
    if (portalContainer && node.contains(portalContainer)) return;
    node.setAttribute('aria-hidden', 'true');
  });
};
const removeAriaHidden = _ref2 => {
  let {
    outsideElements = []
  } = _ref2;
  outsideElements.forEach(node => {
    if (!node) return;
    if (includes$1(TAG_NAME_INVALID, node.tagName)) return;
    if (node.getAttribute('aria-hidden')) node.removeAttribute('aria-hidden');
  });
};
const useModal = _ref3 => {
  let {
    isOpen,
    portalSelector,
    portalContainer
  } = _ref3;
  const [outsideElements, setOutsideElements] = useState([]);
  const [portalElements, setPortalElements] = useState([]);
  useEffect(() => {
    const {
      bodyElements,
      portalElements: _portalElements
    } = getElementsBySelector(portalSelector);
    setOutsideElements(bodyElements);
    setPortalElements(_portalElements);
  }, [portalSelector]);
  useEffect(() => {
    if (isOpen) {
      addAriaHidden({
        outsideElements,
        portalContainer,
        portalElements
      });
    }
    return () => {
      removeAriaHidden({
        outsideElements
      });
    };
  }, [isOpen, portalContainer, outsideElements, portalElements]);
};
export { addAriaHidden, useModal as default, getElementsBySelector, removeAriaHidden };
